import { LessonComponentStyleType } from '../../../models/LessonComponentStyleType';
import { ListComponent } from '../../../models/LessonComponent';
import { ListComponentEditor } from './ListComponentEditor';
import { ListComponentView } from './ListComponentView';
import React from 'react';
import { useLessonContext } from '../../../models/LessonContext';

interface ListProps {
  styleType: LessonComponentStyleType;
  component: ListComponent;
  placeholder?: string;
}
export const List = (props: ListProps) => {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <ListComponentEditor {...props} />
  ) : (
    <ListComponentView component={props.component} />
  );
};
